import React, { useEffect, useState } from 'react';

import { DateInputWithConfirm, getStringFromDate, getDateFromString, SelectWithConfirm } from 'shared-components';

import { RequestNewTravelTicketDropdownOptions, validateDate } from '../../helpers';
import { ITravelStatus, IDate } from '../../../../../../types';
import { useTranslation } from "react-i18next";

interface IProps {
  setComplete: (status: boolean) => void;
  travelStatus: ITravelStatus;
  additionalAnswers: {
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
  setIsEdited: () => void;
}
export const Booked = (props: IProps) => {
    const { t } = useTranslation('dialogs');
  const {
    setComplete,
    travelStatus,
    additionalAnswers: { setAnswers },
    setIsEdited,
  } = props;

  const [bookedDateError, setBookedDateError] = useState('');
  const [dateState, setDateState] = useState<IDate>(getDateFromString(travelStatus.bookedDate));
  const [requestNewTravelTicket, setRequestNewTravelTicket] = useState<'Yes' | 'No' | undefined>();

  useEffect(() => {
    if (
      Boolean(
        !bookedDateError.length && dateState.DD?.length && dateState.MM?.length && dateState.YYYY?.length === 4,
      ) &&
      requestNewTravelTicket
    ) {
      const newDate = getStringFromDate(dateState);
      setAnswers({
        bookedDate: newDate,
        requestNewTravelTicket: requestNewTravelTicket === 'Yes',
      });
      setComplete(true);
    } else {
      setComplete(false);
    }
  }, [dateState, setAnswers, setComplete, bookedDateError, requestNewTravelTicket]);

  const handlerTicketRequestChange = (evt: React.FormEvent<HTMLSelectElement>) => {
    setRequestNewTravelTicket(evt.currentTarget.value as 'Yes' | 'No');
    setIsEdited();
  };

  return (
    <>
      <DateInputWithConfirm
        value={dateState}
        errorText={bookedDateError}
        hideErrorText={true}
        label={t('dialogs:dateOfArrival2')}
        onChangeDD={(evt: any) => {
          const { value } = evt.currentTarget;
          setDateState(prevValue => ({ ...prevValue, DD: value }));
          setIsEdited();
        }}
        onChangeMM={(evt: any) => {
          const { value } = evt.currentTarget;
          setDateState(prevValue => ({ ...prevValue, MM: value }));
          setIsEdited();
        }}
        onChangeYY={(evt: any) => {
          const { value } = evt.currentTarget;
          if (value.length === 4) {
            setBookedDateError(
              validateDate({
                ...dateState,
                YYYY: value,
              }),
            );
          }
          setDateState(prevValue => ({ ...prevValue, YYYY: value }));
          setIsEdited();
        }}
        onBlur={() => setBookedDateError(validateDate(dateState))}
      />

      <SelectWithConfirm
        id={'arrivalStatus'}
        label={t('dialogs:requestUpdateTravelTicketForThis')}
        options={RequestNewTravelTicketDropdownOptions}
        value={requestNewTravelTicket}
        placeHolder={t('dialogs:select')}
        onChange={(evt: any) => handlerTicketRequestChange(evt)}
      />
    </>
  );
};
